import React from 'react';
import uniqid from 'uniqid';
import get from 'lodash/get';

import { StudentDetails } from '../StudentProgressDetails';

const createStudentDetailsList = (students, report, submittedStudents = []) => {
  const studentsWhoHaveNotStarted = [];
  const studentsWhoHaveNotSubmitted = [];
  const studentsWhoHaveSubmitted = [];

  const reportsData = get(report, 'data', {});
  const activityIDs = Object.keys(reportsData);
  const activityReport =
    activityIDs.length === 1 ? reportsData[activityIDs[0]] : {};
  const reportByUser = get(activityReport, 'users', {});

  students.forEach((student) => {
    const { id, firstName, lastName } = student || {};
    const userReport = get(reportByUser, id, null);

    if (!userReport) {
      studentsWhoHaveNotStarted.push(
        <StudentDetails
          key={uniqid()}
          firstName={firstName}
          lastName={lastName}
          showProgressPercentage={false}
        />,
      );
      return;
    }

    const { score, max_score: maxScore } = userReport;
    const progressPercentage = Math.round((score / maxScore) * 100);
    const component = (
      <StudentDetails
        key={uniqid()}
        firstName={firstName}
        lastName={lastName}
        progressPercentage={progressPercentage}
        showProgressPercentage
      />
    );

    if (submittedStudents.includes(id)) {
      studentsWhoHaveSubmitted.push(component);
    } else {
      studentsWhoHaveNotSubmitted.push(component);
    }
  });
  return {
    studentsWhoHaveNotStarted,
    studentsWhoHaveNotSubmitted,
    studentsWhoHaveSubmitted,
  };
};

export default createStudentDetailsList;
